import { BrowserRouter, Routes, Route, Outlet, useNavigate } from "react-router-dom";
import { Container } from "@mui/material";

import Topbar from "./layout/Topbar";
import Sidebar from "./layout/Sidebar";
import Footer from "./layout/Footer";

import IndexLogin from "./pages/index";
import WebsiteData from "./pages/website-data";
import Advertising from "./pages/advertising";
import Performance from "./pages/performance";
import ReviewManager from "./pages/marketing/review-manager";
import Menu from "./pages/menu";
import FileMenu from "./pages/file-menu";
import OpeningHours from "./pages/opening-hours";
import PopUp from "./pages/pop-up";
import ColorScheme from "./pages/color-scheme";
import Settings from "./pages/settings";
import AccountBilling from "./pages/account-billing";
import AccountSettings from "./pages/account-settings";
import Integrations from "./pages/integrations";
import Users from "./pages/users";
import Faq from "./pages/faq";
import Contact from "./pages/contact";

import GoogleMyBusinessPlace from "./pages/integrations/google-my-business-place";
import FacebookMetaAdAccounts from "./pages/integrations/facebook-meta-ad-accounts";
import GoogleAnalyticsProperty from "./pages/integrations/google-analytics-property";
import GoogleAdsCustomer from "./pages/integrations/google-ads-customer";

import { AuthProvider, useAuth } from "./context/AuthContext";


// ────────────────────────────────────────────────
// Dashboard Layout (Context Based)
// ────────────────────────────────────────────────
function DashboardLayout() {
  const { userData, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        Loading...
      </div>
    );
  }

  if (!userData) {
    navigate("/");
    return null;
  }

  return (
    <>
      <Topbar />
      <Sidebar open={true} />

      <div
        style={{
          marginLeft: "264px",
          marginTop: "84px",
          transition: "all 0.3s ease",
        }}
      >
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
          <main style={{ minHeight: "calc(100vh - 144px)" }}>
            <Outlet />
          </main>
          <Footer />
        </Container>
      </div>
    </>
  );
}


// ────────────────────────────────────────────────
// Main App
// ────────────────────────────────────────────────
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>

        <Routes>

          <Route path="/" element={<IndexLogin />} />

          <Route element={<DashboardLayout />}>
            <Route path="website-data" element={<WebsiteData />} />
            <Route path="advertising" element={<Advertising />} />
            <Route path="performance" element={<Performance />} />
            <Route path="marketing/review-manager" element={<ReviewManager />} />

            <Route path="menu" element={<Menu />} />
            <Route path="file-menu" element={<FileMenu />} />
            <Route path="opening-hours" element={<OpeningHours />} />
            <Route path="pop-up" element={<PopUp />} />
            <Route path="color-scheme" element={<ColorScheme />} />

            <Route path="settings" element={<Settings />} />
            <Route path="account-billing" element={<AccountBilling />} />
            <Route path="account-settings" element={<AccountSettings />} />
            <Route path="integrations" element={<Integrations />} />

            <Route path="integrations/google-my-business-place" element={<GoogleMyBusinessPlace />} />
            <Route path="integrations/facebook-meta-ad-accounts" element={<FacebookMetaAdAccounts />} />
            <Route path="integrations/google-analytics-property" element={<GoogleAnalyticsProperty />} />
            <Route path="integrations/google-ads-customer" element={<GoogleAdsCustomer />} />

            <Route path="users" element={<Users />} />
            <Route path="faq" element={<Faq />} />
            <Route path="contact" element={<Contact />} />
          </Route>

          <Route path="*" element={<div>404 Not Found</div>} />

        </Routes>

      </BrowserRouter>
    </AuthProvider>
  );
}